import { SUCCESS, ERROR } from "assets/constants/toastTypes.js"

export const useToastStore = defineStore(
	"toastStore",
	() => {
		const message = ref("")
		const type = ref("")

		const setMessage = (msg: string, msgType: string) => {
			message.value = msg
			type.value = msgType

			//Remove the messages after 10 seconds
			setTimeout($reset, 3000)
		}

		const setSuccess = (msg: string) => {
			setMessage(msg, SUCCESS)
		}

		const setError = (msg: string) => {
			setMessage(msg, ERROR)
		}

		const afterHydrate = () => {
			setTimeout($reset, 3000)
		}

		const $reset = () => {
			message.value = ""
			type.value = ""
		}

		return {
			message,
			type,
			setMessage,
			setSuccess,
			setError,
			afterHydrate,
			$reset,
		}
	},
	{
		persist: {
			//Need to reset the timeout here to keep the toast after the page loads
			afterHydrate: (ctx) => {
				ctx.store.afterHydrate()
			},
		},
	},
)
